// extracted by mini-css-extract-plugin
module.exports = {"root":"CosmeticCreateEdit_root__2W4J6"};